var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhiteBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.334,
    height: 15.37,
    viewBox: "0 0 13.334 15.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.334,
    height: 15.37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.053)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(6.053)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.676,2.256a4.513,4.513,0,0,1,1.417.737,4.57,4.57,0,0,1,1.833,3.732c.005.831,0,1.663,0,2.494A.686.686,0,0,0,24,9.507c.26.531.533,1.054.791,1.586a1.549,1.549,0,0,1-1.053,2.19,1.742,1.742,0,0,1-.38.039q-4.038,0-8.076,0a1.551,1.551,0,0,1-1.593-1.4,1.435,1.435,0,0,1,.162-.85c.256-.509.516-1.016.763-1.528A.882.882,0,0,0,14.7,9.18c.007-.794,0-1.588,0-2.382a4.625,4.625,0,0,1,3.175-4.515c.025-.009.049-.02.073-.03A1.557,1.557,0,0,1,18.439.275a1.527,1.527,0,0,1,1.818.051,1.545,1.545,0,0,1,.419,1.93m-.852-.724a.5.5,0,0,0-.519-.512.51.51,0,0,0-.5.514.511.511,0,0,0,1.022,0",
    transform: "translate(-12.649 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,16.551a6.685,6.685,0,0,1,3.286-5.362.513.513,0,0,1,.6-.006.505.505,0,0,1,.207.533.59.59,0,0,1-.318.378,5.671,5.671,0,0,0-2.011,2.059,5.574,5.574,0,0,0-.74,2.746A.512.512,0,1,1,0,16.946c-.006-.117,0-.234,0-.395",
    transform: "translate(0 -10.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M126.886,16.7c0,.1,0,.192,0,.288a.52.52,0,0,1-.513.527.509.509,0,0,1-.51-.524,5.691,5.691,0,0,0-2.794-4.845.513.513,0,1,1,.5-.9,6.44,6.44,0,0,1,1.527,1.227,6.656,6.656,0,0,1,1.791,4.223",
    transform: "translate(-113.553 -10.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.017,191.174a2.5,2.5,0,0,1-4,0Z",
    transform: "translate(-57.353 -176.81)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteBell);
export default __webpack_public_path__ + "static/media/icon-white-bell.c7bb97bf9f864bce68de4fdfc9d30e8d.svg";
export { ForwardRef as ReactComponent };